<template>
  <div class="index">
    <div class="index-wrap" :class="{ 'download-page': downloadStatus }">
      <div class="nav">
        <p class="logo">
          <img
            class="logo-img"
            alt="logo"
            src="https://res.smoktech.com/files/ccaede67/logo.svg"
          />
          <img
            v-if="!navStatus"
            class="mobile-list"
            @click="toggleNav()"
            src="https://res.smoktech.com/files/0961a5f9/list.svg"
            alt
          />
          <img
            v-else
            class="mobile-close"
            @click="toggleNav()"
            src="https://res.smoktech.com/files/74c63c45/close.png"
            alt
          />
        </p>
        <!-- <h2>{{ $t("message.home_title") }}</h2> -->
        <h2>Start your IVPS Tour</h2>
        <p class="intro">
          Connect You with Like-Minded People
          <br />Share Professional Expertise For a Better Life
        </p>
        <div class="download">
          <!-- <a href="https://itunes.apple.com/app/id1452737287"> -->
          <img
            @click="gotoDownload('apple')"
            src="https://res.smoktech.com/files/621d11d2/apple.png"
            alt
          />
          <!-- </a> -->
          <!--<a href="https://play.google.com/store/apps/details?id=com.smoktech.smok">-->
          <!-- <a href="https://res.smoktech.com/files/64a50e77/IVPS_Tour_2.2.2-release.apk"> -->
          <img
            @click="gotoDownload('android')"
            src="https://res.smoktech.com/files/3d22cc02/android.png"
            alt
          />
          <!-- </a> -->
          <a
            v-if="androidStatus"
            class="android"
            href="https://res.smoktech.com/files/64a50e77/IVPS_Tour_2.2.2-release.apk"
            download="IVPS_Tour_2.2.2-release.apk"
            >Invalid page? Please click here</a
          >
        </div>
        <div class="navigation" :class="{ 'mobile-nav': navStatus }">
          <router-link class="nav-link" to="/home">Home</router-link>
          <br />
          <router-link class="nav-link" to="/about">About</router-link>
          <br />
          <router-link class="nav-link" to="/privacy-policy">Privacy Policy</router-link>
          <br />
          <router-link class="nav-link" to="/terms-of-use">Terms of Use</router-link>
          <br />
          <!-- <div class="nav-link" to="" @click="switchLang()">{{ lang }}</div> -->
        </div>
      </div>
      <div class="content">
        <router-view />
      </div>
    </div>
    <div class="overlay-full" id="warning-message" v-show="is_warning">
      <div class="warning-frame">
        <div class="warning-title">{{ $t("Warning.WARNING") }}</div>
        <div class="warning-content">
          <p>
            {{ $t("Warning.slogan") }}
          </p>
          <p>
            {{ $t("Warning.age") }}
          </p>
        </div>
        <div class="warning-footer">
          <div class="warning-footer-button">
            <span class="line-button cancel" id="warning-leave" @click="goBlack()"
              >{{ $t("Warning.UNDER") }} 21</span
            >
          </div>
          <div class="warning-footer-button">
            <span class="line-button confirm" id="warning-enter" @click="confirmEnter()"
              >21 +</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      navStatus: false,
      downloadStatus: false,
      androidStatus: false,
      lang: "",
      is_warning: false,
      warning_text: "",
    };
  },
  watch: {
    $route: {
      handler: function (val) {
        this.toggleNav(1);
        window.scrollTo(0, 0);
        this.initPage(val);
      },
    },
  },
  mounted() {
    this.initPage(this.$route);
    // this.lang = this.$cookies.get("LANG") == "cn" ? "中文" : "English";
  },
  methods: {
    initPage(val) {
      this.downloadStatus = val.name !== "home";
      let browser = this.checkBrowser();
      if (browser.isAndroid) {
        this.androidStatus = true;
      }
    },
    toggleNav(status) {
      this.navStatus = status ? false : !this.navStatus;
    },
    checkBrowser() {
      let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        // isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        iPad = /(?:iPad)/.test(ua),
        isPc = !isPhone && !isAndroid && !isSymbian;
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        iPad: iPad,
        isPc: isPc,
      };
    },
    switchLang() {
      if (this.lang == "English") {
        this.lang = "中文";
        // this.$cookies.set("LANG", "cn", "1d");
      } else {
        this.lang = "English";
        // this.$cookies.set("LANG", "en", "1d");
      }
      location.reload();
    },
    gotoDownload(value) {
      this.is_warning = true;
      this.warning_text = value;
    },
    confirmEnter() {
      if (this.warning_text == "apple") {
        window.location.href = "https://itunes.apple.com/app/id1452737287";
      } else if (this.warning_text == "android") {
        window.location.href =
          "https://res.smoktech.com/files/64a50e77/IVPS_Tour_2.2.2-release.apk";
      }
      this.is_warning = false;
    },
    goBlack() {
      window.location.href = "about:blank";
    },
  },
};
</script>

<style>
.index {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url("https://res.smoktech.com/files/73631b1f/pc_bg.png") center center
    no-repeat;
  background-size: 100% 100%;
}

.index-wrap {
  width: 1300px;
  margin: 0 auto;
  padding-top: 110px;
}

.nav,
.content {
  float: left;
  width: 50%;
}

.logo {
  height: 72px;
  margin: 15px 0 100px;
}

.logo-img {
  object-fit: contain;
  height: 100%;
}

.mobile-list,
.mobile-close {
  display: none;
}

.nav h2 {
  font-size: 42px;
  font-weight: bold;
  color: #333;
  margin-bottom: 21px;
}

.nav .intro {
  line-height: 34px;
  font-size: 24px;
  color: #777;
}

.download {
  position: relative;
  margin: 45px 0 60px;
}

.android {
  position: absolute;
  bottom: -24px;
  left: 264px;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  color: #03aef9;
}

.download a:first-child {
  margin-right: 30px;
}

.download img:first-child {
  margin-right: 30px;
}

.nav-link {
  display: inline-block;
  margin-bottom: 12px;
  padding-bottom: 6px;
  font-size: 22px;
  font-weight: bold;
  color: #03aef9;
  text-decoration: none;
  border-bottom: 3px solid transparent;
}

.nav-link.router-link-active {
  border-bottom: 3px solid #03aef9;
}

/* 警告框 */
.overlay-full {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  background: transparent; /*不支持rgba的浏览器*/
  background-color: #000;
  background: rgba(0, 0, 0, 0.8); /*支持rgba的浏览器*/
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#CC000000, endColorstr=#CC000000);
}

.warning-frame {
  position: fixed;
  /* 制定是否要剪辑的顶部/底部边缘的内容 */
  overflow-y: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 840px;
  /* height: 540px; */
  color: #000;
  z-index: 200;
  background-color: #fff;
  padding: 0 100px;
}

.warning-title {
  text-align: center;
  font-size: 48px;
  text-transform: uppercase;
  line-height: 45px;
  font-weight: bold;
  margin: 56px 0 59px;
}

.warning-content {
  font-size: 18px;
  letter-spacing: 1px;
  line-height: 1.5;
  text-align: left;
}

.warning-info {
  display: inline-block;
  font-size: 18px;
  color: #1988ff;
  cursor: pointer;
  margin: 25px 0;
}

.warning-footer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 43px 0 60px;
}

.warning-footer-button {
  display: inline-block;
  text-align: center;
}

.line-button {
  font-size: 26px;
  border: 1px solid #000;
  display: inline-block;
  text-transform: uppercase;
  /* 文字不换行 */
  white-space: nowrap;
  cursor: pointer;
  width: 300px;
  height: 60px;
  line-height: 60px;
  overflow: hidden;
}

.warning-footer-button .confirm {
  background-color: #000;
  color: #fff;
}

.warning-footer-button .cancel {
  background-color: #ffffff;
}

@media (max-width: 1600px) {
  .index-wrap {
    width: 1160px;
    padding-top: 70px;
  }

  @media (max-width: 1024px) {
    .index {
      height: auto;
      background: url("https://res.smoktech.com/files/ac6fee06/mb_bg.png") center center
        no-repeat;
      background-size: 100% 100%;
      text-align: center;
    }

    .index-wrap {
      width: 490px;
      margin: 95px auto 0;
      /* padding-top: 70px; */
    }

    .download-page {
      width: 100%;
      margin: 95px 0 0;
      padding: 0;
    }

    .download-page .nav h2,
    .download-page .intro,
    .download-page .download {
      display: none;
    }

    .download-page .content {
      padding: 0;
    }

    .nav,
    .content {
      float: none;
      width: 100%;
    }

    .logo {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 103;
      height: 98px;
      margin: 0;
      padding: 23px 36px 25px;
      text-align: left;
      background: #ffffff;
      border-bottom: 1px solid #ebebeb;
    }

    .logo-img {
      margin-left: 11px;
    }

    .mobile-list,
    .mobile-close {
      display: inline-block;
      float: right;
      margin-top: 9px;
      height: 32px;
      cursor: pointer;
    }

    .mobile-close {
    }

    .nav h2 {
      color: #03aef9;
      margin: 30px 0 36px;
    }

    .navigation {
      position: fixed;
      top: -352px;
      left: 0;
      right: 0;
      z-index: 102;
      background: #ffffff;
      transition: all 0.3s;
    }

    .mobile-nav {
      top: 98px;
    }

    .nav-link,
    .nav-link.router-link-active {
      display: inline-block;
      width: 100%;
      height: 88px;
      line-height: 88px;
      margin: 0;
      padding: 0;
      color: #333;
      font-size: 28px;
      font-weight: normal;
      border-bottom: 1px solid #ebebeb;
    }

    .content {
      padding-bottom: 130px;
    }

    .download {
      margin: 57px 0 93px;
    }

    .download img {
      width: 228px;
      height: 68px;
    }

    @media (max-width: 480px) {
      .index-wrap {
        width: 360px;
        margin: 95px auto 0;
        /* padding-top: 50px; */
      }

      .download-page {
        width: 100%;
        margin: 95px 0 0;
        padding: 0;
      }

      .download-page .nav h2,
      .download-page .intro,
      .download-page .download {
        display: none;
      }

      .download-page .content {
        padding: 0;
      }

      .logo {
        padding: 20px 30px 22px;
      }

      .mobile-list,
      .mobile-close {
        margin-top: 12px;
      }

      .nav h2 {
        font-size: 30px;
        margin: 0 0 26px;
      }

      .nav .intro {
        font-size: 18px;
        line-height: 24px;
      }

      .content {
        padding-bottom: 100px;
      }

      .download {
        /* margin: 57px 0 93px; */
      }

      .android {
        bottom: -48px;
        left: 190px;
      }

      .download img {
        width: 161px;
        height: 48px;
      }

      @media (max-width: 340px) {
        .index-wrap {
          width: 300px;
          margin: 70px auto 0;
          /* padding-top: 50px; */
        }

        .download-page {
          width: 100%;
          margin: 70px 0 0;
          padding: 0;
        }

        .download-page .nav h2,
        .download-page .intro,
        .download-page .download {
          display: none;
        }

        .download-page .content {
          padding: 0;
        }

        .logo {
          height: 70px;
          padding: 15px 30px 17px;
        }

        .navigation {
          top: -220px;
        }

        .mobile-nav {
          top: 70px;
        }

        .nav-link,
        .nav-link.router-link-active {
          height: 72px;
          line-height: 72px;
          font-size: 22px;
        }

        .mobile-list,
        .mobile-close {
          margin-top: 3px;
        }

        .nav h2 {
          font-size: 26px;
          margin: 0 0 26px;
        }

        .nav .intro {
          font-size: 16px;
          line-height: 24px;
        }

        .content {
          padding-bottom: 80px;
        }

        .download {
          margin: 47px 0 63px;
        }

        .android {
          bottom: -38px;
          left: 160px;
          line-height: 19px;
        }

        .download img {
          width: 130px;
          height: 39px;
        }
      }
    }

    @media (max-width: 720px) {
      .overlay-full {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 200;
        width: 100%;
        height: 100%;
        overflow-y: hidden;
        background: transparent; /*不支持rgba的浏览器*/
        background-color: #000;
        background: rgba(0, 0, 0, 0.8); /*支持rgba的浏览器*/
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#CC000000, endColorstr=#CC000000);
      }

      .warning-frame {
        padding: 0 20px;
        position: fixed;
        /* 制定是否要剪辑的顶部/底部边缘的内容 */
        overflow-y: hidden;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 90%;
        height: 400px;
        color: #000;
        z-index: 200;
        background-color: #fff;
        margin: 0 20px;
      }

      .warning-title {
        text-align: center;
        font-size: 24px;
        text-transform: uppercase;
        line-height: 22.5px;
        font-weight: bold;
        margin: 28px 0 29.5px;
      }

      .warning-content {
        font-size: 14px;
        line-height: 1.5;
        text-align: left;
      }

      .warning-info {
        display: inline-block;
        font-size: 13px;
        color: #1988ff;
        cursor: pointer;
        margin: 16px 0;
      }

      .warning-footer {
        display: inline-block;
      }

      .warning-footer-button {
        width: 100%;
        display: inline-block;
        text-align: center;
      }

      .line-button {
        font-size: 18px;
        border: 1px solid #000;
        display: inline-block;
        text-transform: uppercase;
        /* 文字不换行 */
        white-space: nowrap;
        cursor: pointer;
        width: 100%;
        height: 40px;
        line-height: 40px;
        overflow: hidden;
      }

      .warning-footer-button .confirm {
        background-color: #000;
        color: #fff;
      }

      .warning-footer-button .cancel {
        background-color: #ffffff;
      }
    }
  }
}
</style>
